import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Dad, DadSubscriberData} from '../models/dad';
import {DadItemReport} from '../models/dadItemReport';
import {formatDate} from '@angular/common';

@Injectable()
export class DadService {

  constructor(private httpClient: HttpClient) {
  }

  getDads(dateFilterFrom: Date, dateFilterTo: Date): Observable<Dad[]> {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<Dad[]>(environment.baseUrlWs + '/api/dad?usageMonth[after]=' + dateFilterFrom.toJSON() + '&usageMonth[before]=' + dateFilterTo.toJSON());
  }

  getReportingEmails(): Observable<string> {
    return this.httpClient.get<string>(environment.baseUrlWs + '/api/dad-admin/reporting-emails');
  }

  getExchanges(): Observable<string[]> {
    return this.httpClient.get<string[]>(environment.baseUrlWs + '/api/dad-admin/exchange-names');
  }

  getDadByUniqid(uniqid: string): Observable<Dad> {
    return this.httpClient.get<Dad>(environment.baseUrlWs + '/api/dad/dad-form?uniqid=' + uniqid);
  }

  getPreviousMonthDad(uniqid: string): Observable<DadSubscriberData> {
    return this.httpClient.get<DadSubscriberData>(environment.baseUrlWs + '/api/dad/previous-dad/' + uniqid);
  }

  getClientIp(): Observable<string> {
    return this.httpClient.get<string>(environment.baseUrlWs + '/api/user-ip');
  }

  submitDadFormDeclaration(dadUniqid: string, dad: any) {
    return this.httpClient.put(environment.baseUrlWs + '/api/dad/dad-declaration/' + dadUniqid, dad);
  }

  downloadPdf(uniqid: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/dad/' + uniqid + '/pdf', {
      observe: 'response',
      responseType: 'arraybuffer'
    });
  }

  exportDadFormPdfs(dadsUniqIds: string[]) {
    return this.httpClient.post(environment.baseUrlWs + '/api/dad-admin/pdf-archive', {'uniqIds': dadsUniqIds}, {responseType: 'arraybuffer'});
  }

  alterAutoReport(uniqid: string) {
    return this.httpClient.put(environment.baseUrlWs + '/api/dad/' + uniqid + '/alter-auto-report', null);
  }

  getDadListForStatus(exchanges: any[], dateFilterFrom: Date, dateFilterTo: Date, companies: any[]) {
    const dadStatusOptions = {
      'dateFrom': formatDate(dateFilterFrom, 'MM/dd/yyyy', 'en-US'),
      'dateTo': formatDate(dateFilterTo, 'MM/dd/yyyy', 'en-US'),
      'exchanges': exchanges,
      'companies': companies
    };
    return this.httpClient.post(environment.baseUrlWs + '/api/dad-admin/status', dadStatusOptions, {responseType: 'arraybuffer'});
  }

  getComparisonReport(exchanges: any[], dateFilterFrom: Date, dateFilterTo: Date, companies: any[]) {
    const dadStatusOptions = {
      'dateFrom': formatDate(dateFilterFrom, 'MM/dd/yyyy', 'en-US'),
      'dateTo': formatDate(dateFilterTo, 'MM/dd/yyyy', 'en-US'),
      'exchanges': exchanges,
      'companies': companies
    };
    return this.httpClient.post(environment.baseUrlWs + '/api/dad-admin/comparison-report', dadStatusOptions, {responseType: 'arraybuffer'});
  }

  generateDads() {
    return this.httpClient.get(environment.baseUrlWs + '/api/dad-admin/generate');
  }

  sendReminders() {
    return this.httpClient.get(environment.baseUrlWs + '/api/dad-admin/send-reminders');
  }

  dadItemsReport(): Observable<DadItemReport[]> {
    return this.httpClient.get<DadItemReport[]>(environment.baseUrlWs + '/api/dad-admin/item-report');
  }

  dadReport(options: any) {
    const csvOptions = {
      'exchange': options.exchange,
      'mode': options.mode,
      'date': options.date
    };
    return this.httpClient.post(environment.baseUrlWs + '/api/dad-admin/report', csvOptions, {responseType: 'arraybuffer'});
  }

  getRecentlyDisabledPops(uniqid: string): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/dad/' + uniqid + '/recently-deconfig-pops');
  }

  editBoxUrl(dad: Dad, boxUrl: string) {
    const payload = {
      'boxUrl': boxUrl,
    };
    return this.httpClient.put(environment.baseUrlWs + '/api/dad/box-url/' + dad.uniqid , payload);
  }
}
